import module from 'contabilidad/polizas/module.js'
import template from './template.html'

export class ContabilidadPolizasProvisioningresospagosListaClienteComponent {
  cliente
  polizas
  expandido = true

  toggle () {
    this.expandido = !this.expandido
  }
}

module.component('contabilidadPolizasProvisioningresospagosListaCliente', {
  controller: ContabilidadPolizasProvisioningresospagosListaClienteComponent,
  template,
  bindings: {
    cliente: '<',
    polizas: '<',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/provisioningresospagos/lista/cliente/component.js